import type {ReactElement} from 'react';
import React from 'react';
import {BaseItemInvertOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-invert-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';

export function ItemInvertOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemInvert = useGetKeyFromEffectsActiveItem('invert');

  if (!activeItem) {
    throw new Error('Active item does not exist in item invert option');
  }

  if (!('effects' in activeItem) || activeItemInvert === undefined) {
    throw new Error(`Item doesn't have effects property`);
  }

  const onToggleOption = (): void => {
    void activeItem.updateFromObject({
      effects: {
        invert: !activeItemInvert,
      },
    });
  };

  return <BaseItemInvertOption isChecked={activeItemInvert} onToggleOption={onToggleOption} />;
}
